import React from 'react';
import {useAuth} from "../context/AuthContext";
import {Outlet, useNavigate} from "react-router-dom";

const ProtectedRoutes = () => {
    const { currentUser} = useAuth()
    const navigate = useNavigate()
    return (
        currentUser ? <Outlet /> : navigate('signin')
    );
};

export default ProtectedRoutes;